
import Vue from 'vue';
import QueueManagmentIndex from '../components/queue/QueueManagmentIndex.vue';
Vue.component('queue-management-index', QueueManagmentIndex);

export default Vue.extend({
  components: { QueueManagmentIndex },
});
